import { connectRouter } from 'connected-react-router';

export default history => connectRouter(history);
